import React from "react";
import Behance from "../assets/generalicons/behance.png";
import Github from "../assets/generalicons/github.png";
import LinkedIn from "../assets/generalicons/linkedin.png";
import Gmail from "../assets/generalicons/mail.png";

const IconGroup = () => {
  return (
    <React.Fragment>
      <div className="btn-group" role="group">
        <button type="button" className="logo">
          <a
            href="https://www.behance.net/shelcia"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Behance} alt="behancelogo" className="social-up" />
          </a>
        </button>
        <button type="button" className="logo">
          <a
            href="https://github.com/shelcia"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Github} alt="githublogo" className="social-up" />
          </a>
        </button>
        <button type="button" className="logo">
          <a
            href="https://www.linkedin.com/in/shelcia/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={LinkedIn} alt="linkedinlogo" className="social-up" />
          </a>
        </button>
        <button type="button" className="logo">
          <a
            href="mailto:msm17b011@iiitdm.ac.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Gmail} alt="gmaillogo" className="social-up" />
          </a>
        </button>
      </div>
    </React.Fragment>
  );
};

export default IconGroup;
